<template>
  <main class="printProposal container-fluid mf_container pb_50 mb_50">
    <div class="row mt_15"></div>
    <div class="mt_22 d-flex justify-content-start">
      <h4 class="text-green">保險規劃建議書</h4>
      <div
        class="d-flex justify-content-start download-file"
        @click="downloadReadFriendlyPDF()"
      >
        <img src="@/desktop/views/mf/assets/paperclip.png" alt="" />
        <h5 class="text-orange">友善閱讀操作手冊</h5>
      </div>
    </div>
    <div class="printProposal__step mt_13">步驟1/2:選擇報表</div>
    <h5 class="text-green mt_18">可選報表</h5>
    <!-- ------可選報表------------ -->
    <div class="printProposal__reportList" v-if="reportList.length">
      <div
        class="printProposal__reportList__item"
        v-for="report in reportList"
        :key="report.paraval"
      >
        <div class="printProposal__reportList__item__main">
          <div class="checkbox checkbox-inline mr_5">
            <input
              type="checkbox"
              :id="`report__${report.paraval}`"
              v-model="report.is_checked"
              class="mr_5"
              :disabled="isDisabled"
            />
            <label :for="`report__${report.paraval}`"></label>
          </div>
          <div>{{ report.paradetlno }}</div>
          <a
            href="javascript:;"
            class="ml_10 text-green"
            @click="printProposal(report.paraval)"
            >預覽</a
          >
        </div>
        <div
          class="printProposal__reportList__item__sub"
          v-if="report.paraval == '5' && reportRegular"
        >
          <div class="checkbox checkbox-inline mr_5">
            <input
              type="checkbox"
              :id="`report__reportRegular`"
              v-model="reportRegular"
              class="mr_5"
            />
            <label :for="`report__reportRegular`"></label>
          </div>
          列印至20年後，每隔5年列印至保障期滿
        </div>
      </div>
    </div>
    <!-- 封面樣式 -->
    <div class="printProposal__step mt_13">步驟2/2:設定封面資訊</div>
    <h5 class="text-green mt_18">封面樣式</h5>
    <div class="printProposal__cover row">
      <div
        :class="{ 'order-12': index == 0 }"
        v-for="(cover, index) in coverList"
        :key="cover.paraval"
        style="width: 14%; padding: 0.3%"
      >
        <div class="printProposal__cover mt_10">
          <div class="radio radio-inline mr_7">
            <input
              type="radio"
              name="printProposal__cover"
              :value="cover.paraval"
              :id="`printProposal__cover__${cover.paraval}`"
              v-model="coverSelect"
            />
            <label :for="`printProposal__cover__${cover.paraval}`"></label>
          </div>
          <div class="printProposal__cover__info">
            <div>{{ cover.name }}</div>
          </div>
        </div>
        <div class="printProposal__cover__info__pic" v-if="index != 0">
          <img :src="cover.imgURL" alt="" />
        </div>
      </div>
    </div>
    <!-- 謹致 -->
    <Sincerely
      :sincerelySelect.sync="sincerelySelect"
      :sincerely__otherTitle.sync="sincerely__otherTitle"
      :sincerely__insuredTitle.sync="sincerely__insuredTitle"
      :sincerely__insurerTitle.sync="sincerely__insurerTitle"
    />
    <!-- 服務人員資訊 -->
    <div class="d-flex align-items-center mt_15">
      <h5 class="text-green mr_5">服務人員資訊</h5>
      <a class="btn btn-default mx-2" @click="editServicePopupOpen = true">
        修改
      </a>
    </div>
    <div class="printProposal__serviceInfo mt_15">
      <div class="printProposal__serviceInfo__item mb_5">
        <strong>保險顧問</strong>
        <div>{{ serviceInfo.agnt_name }}</div>
      </div>
      <div class="printProposal__serviceInfo__item mb_5">
        <strong>服務單位</strong>
        <div>{{ serviceInfo.cevnm }}</div>
      </div>
      <div class="printProposal__serviceInfo__item mb_5">
        <strong>公司電話</strong>
        <div>({{ serviceInfo.corp_tel_area }}){{ serviceInfo.corp_tel }}</div>
      </div>
      <div class="printProposal__serviceInfo__item mb_5">
        <strong>行動電話</strong>
        <div>{{ serviceInfo.mobile }}</div>
      </div>
      <div class="printProposal__serviceInfo__item mb_5">
        <strong>MAIL</strong>
        <div>{{ serviceInfo.email }}</div>
      </div>
    </div>
    <div class="d-flex align-items-center mt_15">
      <h5 class="text-green mr_5">服務人員資訊2</h5>
    </div>
    <div class="d-flex align-items-center mt_15">
      <section class="editServiceForm search pt_0">
        <label class="editServiceForm__inputItem mb_10">
          <span>保險顧問</span>
          <input
            type="text"
            class="form-control form-control-inline"
            style="width: 250px"
            v-model.trim="serviceInfoScope.agnt_name"
            alt="ch"
            maxlength="13"
            placeholder="最多輸入13個中文字"
            @change="checkValidate"
          />
        </label>
        <label class="editServiceForm__inputItem mb_10">
          <span>服務單位</span>
          <input
            type="text"
            class="form-control form-control-inline"
            style="width: 250px"
            v-model.trim="serviceInfoScope.cevnm"
            maxlength="20"
            placeholder="最多輸入20個中文字"
            @change="checkValidate"
          />
        </label>
        <label class="editServiceForm__inputItem mb_10">
          <span>公司電話</span>
          <input
            type="text"
            class="form-control form-control-inline"
            style="width: 40px"
            v-model.trim="serviceInfoScope.corp_tel_area"
            maxlength="4"
            v-mfOnlyNumber="{
              targetObj: serviceInfoScope,
              targetKey: 'corp_tel_area',
            }"
            @input="
              serviceInfoScope.corp_tel_area =
                serviceInfoScope.corp_tel_area.replace(/[^\d]/g, '')
            "
            @change="checkValidate"
          />
          <strong>-</strong>
          <input
            type="text"
            class="form-control form-control-inline"
            style="width: 102px"
            v-model.trim="serviceInfoScope.corp_tel_Number"
            maxlength="15"
            v-mfOnlyNumber="{
              targetObj: serviceInfoScope,
              targetKey: 'corp_tel_Number',
            }"
            @input="
              serviceInfoScope.corp_tel_Number =
                serviceInfoScope.corp_tel_Number.replace(/[^\d]/g, '')
            "
            @change="checkValidate"
          />
          <strong>#</strong>
          <input
            type="text"
            class="form-control form-control-inline"
            style="width: 68px"
            v-model.trim="serviceInfoScope.crop_tel_Ext"
            maxlength="10"
            v-mfOnlyNumber="{
              targetObj: serviceInfoScope,
              targetKey: 'crop_tel_Ext',
            }"
            @input="
              serviceInfoScope.crop_tel_Ext =
                serviceInfoScope.crop_tel_Ext.replace(/[^\d]/g, '')
            "
            @change="checkValidate"
          />
        </label>
        <label class="editServiceForm__inputItem mb_12">
          <span>行動電話</span>
          <div class="position-relative">
            <input
              type="text"
              class="form-control form-control-inline"
              style="width: 250px"
              v-model.trim="serviceInfoScope.mobile"
              data-vv-name="phone"
              v-validate="'phone'"
              :class="{ 'is-invalid': errors.has(`phone`) }"
              maxlength="10"
              v-mfOnlyNumber="{
                targetObj: serviceInfoScope,
                targetKey: 'mobile',
              }"
              @change="checkValidate"
            />
            <span class="waring-text">
              {{ errors.first(`phone`) ? "行動電話格式有誤" : "" }}
            </span>
          </div>
        </label>
        <label class="editServiceForm__inputItem mb_10">
          <span>MAIL</span>
          <div class="position-relative">
            <input
              type="text"
              class="form-control form-control-inline"
              style="width: 250px"
              v-model.trim="serviceInfoScope.email"
              data-vv-name="email"
              v-validate="'email'"
              :class="{ 'is-invalid': errors.has(`email`) }"
              @change="checkValidate"
            />
            <span class="waring-text">
              {{ errors.first(`email`) ? "MAIL格式有誤" : "" }}
            </span>
          </div>
        </label>
      </section>
    </div>
    <EditServicePopup
      :open="editServicePopupOpen"
      @close="editServicePopupOpen = false"
      :serviceInfo.sync="serviceInfo"
    />
    <EmailPopup
      :open="emailPopupOpen"
      @close="emailPopupOpen = false"
      @send="sendEmailHandler($event)"
    />
    <FixedBottom>
      <template slot="@function">
        <div class="d-flex justify-content-end mr_15">
          <router-link
            class="btn btn-default px_5 mr_10"
            to="/mf/query/queryDetail"
            >查詢其他建議書</router-link
          >
          <button
            class="btn btn-primary px_5 mr_10"
            type="button"
            @click="printProposal()"
            :disabled="!is_selected || !isValidate"
          >
            開啟PDF
          </button>

          <button
            class="btn btn-primary px_5 mr_10"
            type="button"
            @click="emailPopupOpen = true"
            :disabled="!isValidate"
            v-show="!this.$store.getters.IsBankUser"
          >
            發送EMAIL
          </button>
        </div>
      </template>
    </FixedBottom>
    <!-- email發送中 -->
    <MfLoading :open="emailSending" content="EMAIL發送中..." />
  </main>
</template>

<script>
import MfLoading from "@/desktop/views/mf/components/MfLoading";
import mf_Mixin from "@/desktop/views/mf/mixin";
import { getCustInfo } from "@/service";
import { mapGetters, mapActions } from "vuex";
import Sincerely from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/Sincerely.vue";
import EditServicePopup from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/EditServicePopup.vue";
import EmailPopup from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/SendEmailPopup.vue";
import _ from "lodash";

import FixedBottom from "@/desktop/views/mf/components/fixedBotton";

export default {
  props: ["checkDailyCalculateRes", "hasQualification"],
  mixins: [mf_Mixin],
  components: {
    Sincerely,
    EditServicePopup,
    FixedBottom,
    EmailPopup,
    MfLoading,
  },
  data() {
    return {
      serviceInfo: {
        name: "",
        mktDeptName: "",
        depPhone: [],
        mobile: "",
        mail: "",
      },
      editServicePopupOpen: false,
      emailPopupOpen: false,
      emailSending: false,
      reportList: [],
      coverSelect: "0",
      sincerelySelect: "2",
      sincerely__otherTitle: "",
      sincerely__insuredTitle: "",
      sincerely__insurerTitle: "",
      coverImgMap: {
        cover1: require("@/desktop/views/mf/assets/cover/1.png"),
        cover2: require("@/desktop/views/mf/assets/cover/2.png"),
        cover3: require("@/desktop/views/mf/assets/cover/3.png"),
        cover4: require("@/desktop/views/mf/assets/cover/4.png"),
        cover5: require("@/desktop/views/mf/assets/cover/5.png"),
        cover6: require("@/desktop/views/mf/assets/cover/6.png"),
      },
      friendlyVersion: "1",
      printMethod: "", //一式兩份(1)、一式一份(2)、全部列印(3)
      reportRegular: false, //列印至XX年後，每隔X年列印至保障期滿
      readFriendlyattachmentInfoMap: {}, //友善閱讀手冊
      isDisabled: false, //一式兩份或一式一份不可選勾選列印清單
      serviceInfoScope: {},
      isValidate: true,
      proposalListScope: [],
      channel_type: "1",
    };
  },
  computed: {
    ...mapGetters(["CustInfo", "UserInfo", "MfViewing"]),
    coverList() {
      return this.$paragrpno.cover_type.map((cover, index) => {
        return {
          ...cover,
          name: index == 0 ? "不列印封面" : `封面${index}`,
          imgURL: this.coverImgMap[cover.paradetlno],
        };
      });
    },
    is_selected() {
      return this.reportList.some((item) => {
        return item.is_checked;
      });
    },
  },
  async created() {
    this.reportList = this.$paragrpno.chapter_iul.map((item) => {
      if (item.paraval == "9") {
        //保費融資章節預設不勾選
        item.is_checked = false;
      } else {
        item.is_checked = true;
      }
      return item;
    });

    this.printMethod = "1";

    let res = await this.$mfAPI.MFA1_1000__queryProposalDetailList({
      agent_id: this.$store.state.userInfo.id,
      insured_id: "",
      prod_idx: this.MfViewing.saveData.prod_idx,
    });
    this.proposal = res.proposal[0];

    this.proposalListScope = this.proposal.mc_prod_list;
    this.channel_type = this.$store.getters.UserChannelType;
    let is_pfin_count = 0;
    this.proposalListScope.forEach((mc) => {
      let is_pfin = mc.is_pfin || "";
      if (is_pfin.split(",").includes(this.channel_type)) {
        is_pfin_count++;
      }
    });
    if (is_pfin_count == 0) {
      this.reportList = this.reportList.filter((item) => item.paraval !== "9");
    }

    //查找登入者資訊(MF)
    let result = await this.$mfAPI.MVI0_0100_query({
      agnt_id: this.$store.state.userInfo.id,
    });
    this.serviceInfo = {
      ...result,
    };
    result = await this.$mfAPI.MFB0_9620__getAttachmentInfo({
      attaname: "友善閱讀操作手冊",
    });
    this.readFriendlyattachmentInfoMap = {
      ...result,
    };
    setTimeout(() => {
      this.registerHanlink();
    }, 100);
  },
  methods: {
    sendEmailHandler($event) {
      this.emailPopupOpen = false;
      this.emailSending = true;
      this.printProposal(null, "send", $event);
    },

    async printProposal(chapter, mode = "print", mailForm) {
      if (!this.checkDailyCalculateRes) return;
      //mode為開啟或寄出：print/send
      let chapter_tp_list = [];
      if (chapter) {
        chapter_tp_list = [chapter];
      } else {
        this.reportList.forEach((item) => {
          if (item.is_checked) {
            chapter_tp_list.push(item.paraval);
          }
        });
      }

      let selectedCover = this.coverList.find(
        (item) => item.paraval == this.coverSelect,
      );
      let toName = "";
      let toSalutation = "";
      switch (this.sincerelySelect) {
        case "1":
          toName = this.MfViewing.insurer.insured_name;
          toSalutation = this.sincerely__insurerTitle;
          break;
        case "2":
          toName = this.MfViewing.insured.insured_name;
          toSalutation = this.sincerely__insuredTitle;
          break;
        case "3":
          toName = this.sincerely__otherTitle;
          break;
      }
      let printObj = {
        prod_idx: this.MfViewing.saveData.prod_idx,
        agent_id: this.$store.state.userInfo.id,
        insured_id: this.MfViewing.saveData.insured_id,
        chapter_tp_list: chapter_tp_list,
        channel_type: this.$store.getters.UserChannelType,
        coverInfoMap: {
          cover_type: chapter ? "0" : selectedCover.paraval,
          cover_type_nm: selectedCover.paradetlno,
          name: toName,
          salutation: toSalutation,
          agent_name: this.serviceInfo.agnt_name,
          corp: this.serviceInfo.cevnm || "",
          corp_tel:
            this.serviceInfo.corp_tel_area +
            (!this.serviceInfo.corp_tel_area
              ? ""
              : "-" + this.serviceInfo.corp_tel),
          mobile: this.serviceInfo.mobile,
          email: this.serviceInfo.email,
          agent_name2: this.serviceInfoScope.agnt_name || "",
          corp2: this.serviceInfoScope.cevnm || "",
          corp_tel2:
            (this.serviceInfoScope.corp_tel_area || "") +
            (!this.serviceInfoScope.corp_tel_Number
              ? ""
              : "-" + this.serviceInfoScope.corp_tel_Number) +
            (!this.serviceInfoScope.crop_tel_Ext
              ? ""
              : "#" + this.serviceInfoScope.crop_tel_Ext),
          mobile2: this.serviceInfoScope.mobile,
          email2: this.serviceInfoScope.email,
        },
        isIUL: true,
        printScopeMap: {
          separate_year: this.reportRegular ? "20" : "999", //"開始列印至"的年度
          interval_year: this.reportRegular ? "5" : "1", //間隔幾年
        },
        kyc_message: "",
        printMethod: this.printMethod,
        hasQualification: this.hasQualification,
      };
      if (mode == "print") {
        var newWindow = window.open("");
        newWindow.document.write(`
          <html style="height: 100%;">
          <head>
          <meta name="viewport" content="width=device-width, minimum-scale=0.1">
          <title>PDF LOADING...</title>
          </head>
          <body style="margin: 0px; background: #0e0e0e; height: 100%">
          <div><img style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;" src="/crm/assets/common/mv-pdf-loader.gif"></div>
          </body></html>
      `);
        if (
          window.location.href.indexOf("localhost") !== -1 ||
          window.location.href.indexOf(process.env.VUE_APP_DEV_IP) !== -1
        ) {
          this.$mfAPI.MFR0_2000__printReport(printObj).then(function (res) {
            let file = new Blob([res.data], { type: "application/pdf" });
            let fileURL = URL.createObjectURL(file);
            newWindow.location = fileURL;
            setTimeout(() => {
              newWindow.document.title = "建議書章節預覽";
            }, 100);
          });
        } else {
          this.$mfAPI
            .MFR0_2000__printReportToFile(printObj)
            .then((response) => {
              let { header, body } = response.data;
              if (parseInt(header.status) < 0) {
                this.$toast.info({ title: `執行失敗` });
                return Promise.reject(header.message);
              } else if(this.$store.getters.IsBFF_MF){
                let targetURL = `${window.location.origin}/mid-mxf0-crm-ui/api/v1/MFR00100/downloadReport?fileNo=${body.fileNo}`;
                newWindow.location = targetURL;
              } else {
                let targetURL = `${this.$store.getters.MfPdfBaseURL}/MFR0_0100/downloadReport?fileNo=${body.fileNo}`;
                newWindow.location = targetURL;
              }
            });
        }
      } else if ((mode = "send" && mailForm)) {
        //寄出email
        this.$mfAPI
          .MFR0_2000__mailReport({
            ...printObj,
            //以下為send專屬
            receiver: mailForm.TO, //收件人信箱
            receiverName: "", //收件人
            subject: mailForm.Title, //信件標題
            receivercc: mailForm.CC, //副本信箱
            sender:
              mailForm.FROM +
              (this.$store.getters.IsBankUser
                ? "@cathaybk.com.tw"
                : "@cathaylife.com.tw"), //寄件人信箱
            channel_type: this.$store.getters.UserChannelType,
          })
          .then(({ data }) => {
            this.emailSending = false;
            if (parseInt(data.header.status) < 0) {
              // this.$toast.info({ title: data.header.message });
              this.$toast.info({ title: "執行失敗" });
            } else {
              this.$toast.info({ title: `發送成功!` });
            }
          })
          .catch((error) => {
            this.emailSending = false;
            // this.$toast.info({ title: `${error}` });
            this.$toast.info({ title: "執行失敗" });
          });
      }
    },
    async printNewContractList(contract) {
      var newWindow =
        this.UserInfo.userType === "box" && !this.isBankUser
          ? window
          : window.open(""); //NAP不開新視窗
      newWindow.document.write(`
          <html style="height: 100%;">
          <head>
          <meta name="viewport" content="width=device-width, minimum-scale=0.1">
          <title>PDF LOADING...</title>
          </head>
          <body style="margin: 0px; background: #0e0e0e; height: 100%">
          <div><img style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;" src="/crm/assets/common/mv-pdf-loader.gif"></div>
          </body></html>
      `);
      let res = await this.$mfAPI.MFR0_1000__previewOtherPDFFile({
        ...contract,
      });
      let blob = new Blob([res.data], { type: "application/json" });
      try {
        let blobReader = new Response(blob);
        const res = await blobReader.json();
        if (parseInt(res.header.status) < 0) {
          //沒有檔案
          return swal(res.header.message, ``, "error");
        }
      } catch {
        let file = new Blob([res.data], { type: "application/pdf" });
        let fileURL = URL.createObjectURL(file);
        newWindow.location = fileURL;
        setTimeout(() => {
          newWindow.document.title = "友善閱讀手冊";
        }, 100);
      }
    },
    downloadReadFriendlyPDF() {
      //友善閱讀手冊下載
      this.printNewContractList(this.readFriendlyattachmentInfoMap);
    },
    async checkValidate() {
      this.isValidate = await this.$validator.validateAll();
    },
  },
  directives: {
    mfOnlyNumber: {
      bind: function (el, binding) {
        el.handler = function () {
          if (binding.value.targetObj && binding.value.targetKey) {
            binding.value.targetObj[binding.value.targetKey] = el.value.replace(
              /\D+/,
              "",
            );
          }
        };
        el.addEventListener("input", el.handler);
      },
      unbind: function (el) {
        el.removeEventListener("input", el.handler);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.printProposal {
  color: #323a45;
  @media (min-width: 1025px) {
    width: 100%;
    max-width: 1280px;
  }
  &__step {
    font-size: 24px;
    color: #323a45;
    font-weight: 700;
  }
  &__reportList {
    padding: 20px 0;
    &__item {
      border-bottom: solid 1px #e0e1e3;
      display: flex;
      flex-direction: column;
      padding: 12px 0 18px;
      &__main {
        display: flex;
        align-items: center;
        line-height: 40px;
      }
      &__sub {
        display: flex;
        align-items: center;
        font-size: 14px;
        padding-left: 42px;
      }
    }
  }
  &__newContractList {
    border-bottom: solid 1px #e0e1e3;
    &__group {
      display: flex;
      flex-wrap: wrap;
      padding-left: 42px;
      &__item {
        width: 33.333%;
        display: flex;
        align-items: center;
      }
    }
  }
  &__cover {
    width: 100%;
    display: flex;
    align-items: flex-start;
    line-height: 40px;
    &__info {
      width: 100%;
      padding-right: 40px;
      &__pic {
        width: 100%;
        border: solid 1px #707070;
        img {
          width: 100%;
          display: flex;
        }
      }
    }
  }
  &__serviceInfo {
    &__item {
      display: flex;
      align-items: center;
      strong {
        display: inline-block;
        margin-right: 10px;
        width: 64px;
        line-height: 1.38;
      }
    }
  }
  .emailSending {
    height: 172px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
  }
}
.download-file {
  text-decoration: underline;
  color: #f58818;
  text-underline-offset: 4px;
  margin-left: 5px;
  cursor: pointer;
  & img {
    width: 24px;
    height: 24px;
  }
}
</style>
